module.exports = __webpack_public_path__ + "static/img/icon_received.1c567942.png";